/**
 * DI-01 — the message the summary turn sends: the spec's analyst framing and the bullet count.
 * The user's own words stay in their bubble; the deck text rides `document_context`.
 */

import type { DeckContext } from "../types";

export function buildDeckSummaryPrompt(bulletCount: number, context: DeckContext): string {
  const bullets = `${bulletCount} ${bulletCount === 1 ? "bullet" : "bullets"}`;
  const lines = [
    `Summarise this presentation in exactly ${bullets}.`,
    "Cover the deck's narrative arc from opening to close: what it sets out, its key points, " +
      "and what it concludes or asks for.",
    "Write one bullet per line as plain text: no heading, no introduction, no numbering and no Markdown.",
  ];
  if (context.truncated) {
    lines.push(
      `The deck is long, so only slides 1 to ${context.slidesIncluded} of ${context.totalSlides} are attached. ` +
        "Summarise those and do not guess at the rest.",
    );
  }
  return lines.join(" ");
}
